export enum AdTechnology {
    SSAI = 'ssai',
    CSAI = 'csai',
}
